import { DateTime } from "luxon";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import DateTimePickerModal from "../DateTimePickerModal";
import { resolveInitialPickerDate } from "./helpers";

type Props = {
	isVisible: boolean;
	onCancel: () => void;
	onConfirm: (date: Date) => void;
	initialDate?: string;
	label?: string;
	ctaLabel?: string;
};

export const ExamDatePickerModal = ({
	isVisible,
	onCancel,
	onConfirm,
	initialDate,
	label,
	ctaLabel,
}: Props) => {
	const { t } = useTranslation();
	const resolvedLabel = label ?? t("common.selectTestDate");
	const resolvedCtaLabel = ctaLabel ?? t("common.save");

	const minimumDate = useMemo(
		() => DateTime.local().startOf("day").toJSDate(),
		[],
	);

	const finalMinDate = useMemo(
		() => resolveInitialPickerDate(initialDate),
		[initialDate],
	);

	return (
		<DateTimePickerModal
			isVisible={isVisible}
			mode="date"
			onConfirm={onConfirm}
			onCancel={onCancel}
			date={finalMinDate}
			minimumDate={minimumDate}
			label={resolvedLabel}
			saveLabel={resolvedCtaLabel}
		/>
	);
};
